<div class="dropdown">
  <button class="dropdown-select" (click)="toggleDropdown($event)" [ngClass]="{dynamicClass, disable: isDropdownDisable}">
    {{ selectedValue || "Select" }}
  </button>
  <div
    class="dropdown-menu"
    [ngClass]="{ show: dropdownVisible }"
    *ngIf="dropdownVisible"
  >
    <ul class="dropdown-list">
      <li
        *ngFor="let option of dropdownValues"
        (click)="selectOption(option, $event)"
        tabindex="0"
        (keyup.enter)="selectOption(option, $event)"
        [ngClass]="{'selected': (option.label == selectedValue)}"
      >
        {{ option.label }}
      </li>
    </ul>
  </div>
</div>
